<template>
  <header class="header">
    <div class="header__container container">
      <div class="header__logo">
        <h3 class="header__logo-text">Alice Rees.</h3>
      </div>
      <div class="header__navigation">
        <navigation />
      </div>
    </div>
  </header>
</template>

<script>
import Navigation from './Navigation.vue';

export default {
  components: {
    Navigation,
  },
};
</script>

<style scoped>
.header {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  display: flex;
  top: 0;
  width: 100%;
  flex-flow: wrap;
  background-color: var(--blue);
}

.header__container {
  display: flex;
  flex-flow: wrap;
  flex: 1;
}

.header__logo {
  color: var(--dark-purple);
  font-family: var(--headline-font);
  font-weight: normal;
  text-align: center;
  width: 100%;
}

.header__logo-text {
  font-size: 32px;
  font-weight: normal;
  padding: 24px;
  margin: 0;
}

.header__navigation {
  display: flex;
  width: 100%;
}

@media screen and (min-width: 640px) {
  .header__logo {
    text-align: left;
    width: 30%;
  }

  .header__navigation {
    width: 70%;
  }
}
</style>
